import React, { useCallback } from 'react';

import {
  APPLY_PRESET,
  useScreenDispatch,
  useScreenState,
} from 'components/Screen';
import Presets from 'presets';

function getPreset(screenState: any = {}) {
  const { filters, metrics, tableSettings, columns, dimension } = screenState;
  return {
    filters,
    metrics,
    tableSettings,
    columns,
    dimension,
  };
}

const ScreenPresets = () => {
  const dispatch = useScreenDispatch();
  const screenState = useScreenState();

  const handleChange = useCallback(
    (value: any) => {
      dispatch({
        type: APPLY_PRESET,
        payload: value,
      });
    },
    [dispatch]
  );

  const presetState = getPreset(screenState);
  return (
    <Presets
      screenKey={'mobile.performance'}
      onApply={handleChange}
      state={presetState}
      activePresetId={screenState.presetID}
    />
  );
};

export default ScreenPresets;
